import { Button, Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { UndoOutlined } from "@ant-design/icons";
import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
const LiveDataControl = ({
    name,
    dataTyp,
    format,
    required,
    data,
    errorMessage,
    type,
    width,
    defaultValue,
    form,
    label,
    labelCol,
    extraParams,
    className = ''
}) => {
    const [value, setValue] = useState("");
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [refreshing, setRefreshing] = useState(false);

    const getLiveValue = () => {
        setRefreshing(true);
        if (!data.method || data.method === 'GET') {
            liracrypt.get(data.api, { data_index: name, ...data.params, ...searchParams, ...extraParams })
                .then(response => {
                    setRefreshing(false);
                    let val = response.data.data?.defaultValue?.toString();
                    if (val) {
                        if (dataTyp === 'integer' || dataTyp === 'decimal') {
                            val = response.data.data?.defaultValue;
                        };
                        // if (dataTyp === 'date') {
                        //     val = moment().add(val, 'days').format(response.data.data?.format || "YYYY-MM-DD");
                        // }
                        if (dataTyp === 'date' || dataTyp === 'dateTime') {
                            val = moment(val).format(format || "YYYY-MM-DD");
                        }
                    }
                    setValue(val);
                    form.setFieldsValue({ [name]: val });

                }).catch(err => {
                    ApiErrorComp();
                    setRefreshing(false);
                    console.log(err);
                })
        };
        if (data.method === 'POST') {
            liracrypt.post(data.api, { ...data.params, ...searchParams, ...extraParams })
                .then(response => {
                    setRefreshing(false);
                    let val = response.data.data?.defaultValue?.toString();
                    if (val) {
                        if (dataTyp === 'integer' || dataTyp === 'decimal') {
                            val = response.data.data?.defaultValue;
                        };
                        // if (dataTyp === 'date') {
                        //     val = moment().add(val, 'days').format(response.data.data?.format || "YYYY-MM-DD");
                        // }
                        if (dataTyp === 'date' || dataTyp === 'dateTime') {
                            val = moment(val).format(format || "YYYY-MM-DD");
                        }
                    }
                    setValue(val);
                    form.setFieldsValue({ [name]: val });
                }).catch(err => {
                    ApiErrorComp();
                    console.log(err);
                })
        };
        if (data.method === 'PATCH') {
            liracrypt.patch(data.api, { ...data.params, ...searchParams, ...extraParams })
                .then(response => {
                    setRefreshing(false);
                    let val = response.data.data?.defaultValue?.toString();
                    if (val) {
                        if (dataTyp === 'integer' || dataTyp === 'decimal') {
                            val = response.data.data?.defaultValue;
                        };
                        // if (dataTyp === 'date') {
                        //     val = moment().add(val, 'days').format(response.data.data?.format || "YYYY-MM-DD");
                        // }
                        if (dataTyp === 'date' || dataTyp === 'dateTime') {
                            val = moment(val).format(format || "YYYY-MM-DD");
                        }
                    }
                    setValue(val);
                    form.setFieldsValue({ [name]: val });
                }).catch(err => {
                    ApiErrorComp();
                    console.log(err);
                })
        };
    }

    // useEffect(() => {
    //     if (defaultValue?.toString()) {
    //         form.setFieldsValue({ [name]: defaultValue });
    //         setValue(defaultValue);
    //     } else {
    //         form.setFieldsValue({ [name]: "" });
    //     }
    // }, []);

    useEffect(() => {
        getLiveValue();
        if (!data.interval) return;
        let interval = setInterval(() => {
            getLiveValue();
        }, data.interval);
        return (() => clearInterval(interval));
    }, [])

    return (
        <Form.Item
            className={`${className} ${type === 'input' ? 'input' : 'textarea'}`}
            name={name}
            label={label}
            labelCol={{ span: labelCol ? labelCol : 8 }}
            wrapperCol={!label ? { span: 24 } : undefined}
            style={{ width: width, fontWeight: 600 }}
            rules={[
                {
                    required: required,
                    message: errorMessage,
                }
            ]}
        >
            <Input
                value={value}
                type="text" disabled={true} suffix={
                    <Button
                        onClick={getLiveValue}
                        type="link"
                        icon={
                            <UndoOutlined
                                style={{ fontSize: 20, color: "#007bff" }}
                                spin={refreshing}
                            />
                        }>{''}</Button>
                } />
        </Form.Item>
    )
};

export default LiveDataControl;